var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrainstrom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3C8.91496 3 6 5.92254 6 9.53846C6 11.8211 7.162 13.8298 8.92476 15H16.0752C17.838 13.8298 19 11.8211 19 9.53846C19 5.92254 16.085 3 12.5 3ZM15.3653 17H9.63473V18H15.3653V17ZM14.2324 20H10.7676C11.1134 20.5978 11.7597 21 12.5 21C13.2403 21 13.8866 20.5978 14.2324 20ZM8.62601 20C9.07004 21.7252 10.6361 23 12.5 23C14.3639 23 15.93 21.7252 16.374 20C16.9223 19.9953 17.3653 19.5494 17.3653 19V16.5407C19.5622 14.9976 21 12.4362 21 9.53846C21 4.82763 17.1992 1 12.5 1C7.80076 1 4 4.82763 4 9.53846C4 12.4362 5.43784 14.9976 7.63473 16.5407V19C7.63473 19.5494 8.07774 19.9953 8.62601 20Z",
    fill: "url(#paint0_linear_3914_22735)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3914_22735",
    x1: 12.5,
    y1: 1,
    x2: 12.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainstrom);
export default __webpack_public_path__ + "static/media/brainstrom.94b1ca1bcd1c87684b0d038fe1536ac1.svg";
export { ForwardRef as ReactComponent };